export default __webpack_public_path__ + "static/media/tv-net.9cbeaba1.png";